// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zVDq","footer":"styles_footer__IRldF"};